<template>
  <div>
<!--    <div>-->
<!--    <div class="remington-typed-font full-height text-align-center">-->
<!--      <div class="inline-block margin-auto width-90 full-height vertical-middle">-->
<!--        <nav class="navigationList inline-block">-->
<!--          <ul>-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'AboutUS'}">General</router-link></li>-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'StructureMain'}">Structure</router-link></li>-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'CampaignsMain'}">Campaigns</router-link></li>&lt;!&ndash;              <li>|</li>&ndash;&gt;-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'ProceduresMain'}">Procedures</router-link></li>-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'RulesMain'}">Rules</router-link></li>-->
<!--          </ul>-->
<!--        </nav>-->
<!--      </div>-->
<!--    </div>-->
<!--    </div>-->
  <div class="typed-on-paper-a4">
    <div class="text-align-center">
      <h1>COMMUNITY BEHAVIOUR RULES</h1>
    </div>
    <br><br>
    <h2>Preamble</h2>
    <p>The “Flying Tin Cans” Community is founded on friendship and respect for like-minded enthusiasts who get together to enjoy each other’s company while battling it out in the virtual skies. The whole point, win or lose, is to have fun as part of a friendly, welcoming community. The following rules are only necessary to provide guidelines towards what we would consider implicit in normal behaviour and to provide recourse for anyone who does feel genuinely aggrieved by any behaviour or incident.</p>
    <h2>Revision History</h2>
    <table>
      <tr>
        <th>TYPE OF ACTION</th>
        <th>UPDATE SCOPE</th>
        <th>UPDATED BY</th>
        <th>DATE</th>
      </tr>
      <tr>
        <td>First Draft</td>
        <td>Drafting of rules</td>
        <td>Woop</td>
        <td>1-NOV-21</td>
      </tr>
    </table>
    <h2>I. Scope of Rules</h2>
    <ol style="margin-left: 1em">
      <li>The following rules:</li>
        <ol type="a" style="margin-left: 2em; margin-top: 1em">
          <li>Apply to the Forums, Discord, Teamspeak, Pilot & Mission Database (PAM) and Website.</li>
          <li>Apply to both public posts, Direct Messages (DMs) and Private Messages (PMs) on all platforms, as well as other affiliated platforms.</li>
          <li>Apply to both serious posts and jokes or memes.</li>
        </ol>
      <li style="margin-top: 1em">Staff and the Board of Directors (hereinafter referred to as the Board) handle Behaviour Rules.</li>
      <li>Rules apply to everyone including Staff and the Board. A member of Staff or the Board accused of breaking the rules may not rule on the issue or retaliate in any way.</li>
      <li>In situations not covered by these rules, Staff and/or the Board have full discretion. While the rules do not apply to non-official Discord servers or other platforms, in extreme cases Staff and/or the Board may act if issues are brought to their attention.</li>
      <li>Changes to the rules should be made public and put up for discussion for at least one week before implementation.</li>
    </ol>
    <h2>II. Behaviour Rules</h2>
    <ol style="margin-left: 1em">
      <li>Everyone must be treated with respect at all times. Personal attacks, slurs, and offensive or discriminatory language are forbidden.</li>
      <li>Trolling is forbidden. This includes deliberately starting or prolonging arguments,
        provoking or antagonizing players, or showing disruptive behaviour.</li>
      <li>Spamming is forbidden. Posting non-game related content in channels for game related
        issues is forbidden and may be deleted. In excessive cases, channels may be temporarily
        set to slow mode or closed.</li>
      <li>Harassment is forbidden. Users can be sanctioned for a pattern of behaviour even if there
        is no specific action in violation of the rules. Players who experience or see harassment
        should immediately notify Staff or the Board so they can monitor the situation and intervene if necessary. Doxxing or threats result in an immediate and permanent ban.</li>
      <li>Offensive, graphically violent, or sexually explicit images, including profile pictures, are
        forbidden. Additionally, use Discord's spoiler feature to hide potentially sensitive images as a courtesy to other users.</li>
      <li>Offensive usernames are forbidden.</li>
      <li>Multiple forum accounts are forbidden.</li>
      <li>Rule violations can be penalized by muting, kicking, or banning on Discord and/or the forums, as well as dismissal from the Community. Staff and the Board have full discretion in their choice of penalty. Repeat offenders will face increasingly harsher penalties.
      </li>
      <li>Please report any rule violations you see to Staff or the Board. Take screenshots in case posts are deleted or edited. Every player has the right at any time to point out rule violations, ask that the rules be applied, and request a member of Staff or the Board to step in. Discouraging players from doing so in any way is forbidden.</li>
      <li>Abuse of rules is forbidden. This is defined as repeatedly pointing out violations for the sake of creating arguments or unrest. </li>
      <li>NSFW content which does not violate point 6 must be kept to the designated NSFW channel on Discord.</li>
    </ol>
  </div>
  </div>
</template>

<script>

  import DivLinkButton from "../basic_comp/DivLinkButton";

  export default {
    name: "InfoTemplate",
    components: {
      DivLinkButton
    }
  }
</script>

<style scoped>

.iconImage {
  max-height: 40px;
}

.navbar-tabs {
  min-height: 0px;
  width: calc(100% - 0px); /* Whished widht in % minus 2x border size */
  padding: 20px;
  padding-bottom: 15px;
  font-family: "Remingtoned Type";
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  background-image: url("/frontend/src/assets/images/ftcpaper-tabs.png");
  /*background: linear-gradient(90deg, #ebebe9 1px, #ebe6e6 1px, #efeeec 1px, #e7e6e4 1px, #eae6e5 1px);*/
  box-shadow: 0px -5px 15px rgba(10,10,10,0.3);
  color: #1b1b1b;
}

.navigationList li {
  display: table-cell;
  font-size: 125%;
  text-align: center;
}

.navigationList li a {
  padding: 0px 40px;
  text-decoration: none;
  font-weight: bold;
  color: #1b1b1b;
}

.navigationList li a:hover{
  color: #1b1b1b;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  /*border-top-left-radius: 15px;*/
  /*border-top-right-radius: 15px;*/
  border-radius: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/info/CommunityBehaviourRules.vue